import React from 'react';

const IconLoader = () => (
  <svg id="logo" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 100 100">
    <title>Loader Logo</title>
    <g>
      <g id="JB" transform="translate(1.000000, 1.000000)">
        <path
          d="M 36.00,28.00
           C 36.00,28.00 42.00,28.00 42.00,28.00
             42.00,28.00 42.00,51.00 42.00,51.00
             41.98,54.08 42.14,57.23 40.26,59.87
             37.91,63.18 33.72,64.15 30.00,65.00
             30.00,65.00 30.00,59.00 30.00,59.00
             30.00,59.00 34.98,55.78 34.98,55.78
             34.98,55.78 36.00,49.00 36.00,49.00
             36.00,49.00 36.00,28.00 36.00,28.00 Z
           M 49.00,28.00
           C 54.84,28.00 66.50,26.61 69.41,33.11
             70.87,36.88 68.97,41.05 69.41,44.00
             70.17,47.05 76.58,54.90 68.78,61.35
             64.31,65.04 54.71,64.00 49.00,64.00
             49.00,64.00 49.00,28.00 49.00,28.00 Z
           M 55.00,43.00
           C 56.94,42.99 60.72,43.26 62.26,42.01
             64.47,40.21 64.31,35.89 61.69,34.60
             60.20,33.87 56.72,34.01 55.00,34.00
             55.00,34.00 55.00,43.00 55.00,43.00 Z
           M 55.00,59.00
           C 57.18,58.47 63.24,57.89 64.49,56.98
             67.02,55.13 66.87,51.09 63.77,49.17
             61.52,47.78 57.60,48.01 55.00,48.00
             55.00,48.00 55.00,59.00 55.00,59.00 Z"
          fill="#24c9aa"
        />
      </g>
      <path
        stroke="currentColor"
        strokeWidth="5"
        strokeLinecap="round"
        strokeLinejoin="round"
        d="M 50, 5
                  L 11, 27
                  L 11, 72
                  L 50, 95
                  L 89, 73
                  L 89, 28 z"
      />
    </g>
  </svg>
);

export default IconLoader;
